<div class="row page-title">
  <span>{{ localizationConstants.TOOL_DETAILS_PAGE_TITLE | translate }}</span>
</div>

<div class="row">
  <div class="o-grid">
    <div
      id="main-info"
      class="c-hero">
      <!-- <div class="row"> -->
      <div class="o-grid"></div>
      <div
        *ngIf="tool"
        class="c-details-box general-info-container">
        <div class="c-details-box__title">{{ tool.modelNumber }}</div>
        <table class="o-list-table o-list-table--thin o-list-table--even full-width--mobile">
          <tr class="o-list-table__item">
            <td
              scope="row"
              class="c-details-box__item">
              {{ "tool.serialnumber" | translate }}
            </td>
            <!-- Intentionally exchanged id with serialNumber -->
            <td class="c-details-box__item">{{ tool.toolId }}</td>
          </tr>
          <tr class="o-list-table__item">
            <td
              class="c-details-box__item"
              scope="row">
              {{ "tool.toolid" | translate }}
            </td>
            <!-- Intentionally exchanged id with serialNumber -->
            <td class="c-details-box__item">{{ tool.serialNumber }}</td>
          </tr>
          <tr class="o-list-table__item">
            <td
              class="c-details-box__item"
              scope="row">
              {{ "tool.type" | translate }}
            </td>
            <td class="c-details-box__item">{{ tool.type }}</td>
          </tr>
        </table>

        <mat-slide-toggle
          *ngIf="canToggleActiveStatus"
          class="example-margin"
          color="primary"
          [(ngModel)]="tool.isActive"
          (change)="updateToolActive(tool.isActive)">
          {{ "toolinfo.active" | translate }}
        </mat-slide-toggle>
        <!-- <div *ngIf="authService.user?.allowEditTool" id="tool-active">
                    <div class="row ">                 
                        <div>
                            <input
                                #isActive  
                                type="checkbox" 
                                name="isActive" 
                                id="isActive" 
                                class="c-checkbox-slider--sm"
                                [(ngModel)]="tool.isActive" 
                                (change)="updateToolActive(tool.isActive)"/>
                            <label for="isActive" class="c-switch-slider--sm"></label>
                        </div>
                        {{ 'toolinfo.active' | translate }}
                    </div>
                </div> -->

        <button
          type="button"
          class="button--sm button-block button-primary"
          (click)="goToServAid()">
          <span class="flex middle center">
            <mat-icon svgIcon="license--maintenance"></mat-icon>
            <span class="button__label">{{
              localizationConstants.BUTTON_SPARE_PARTS_MANUALS | translate
            }}</span></span
          >
        </button>

        <service-request-button
          id="selector-button"
          [tool]="tool"></service-request-button>
        <purchase-order-button
          id="selector-button"
          [tool]="tool"></purchase-order-button>
      </div>
    </div>
  </div>
  <div class="col-sm-8 col-12">
    <div
      *ngIf="tool"
      id="tabs"
      class="tabs row">
      <div class="container col-12 col-lg-offset-2 col-lg-8">
        <ul class="c-tab-details__group">
          <li
            id="tab-status"
            class="c-tab-details__item"
            [routerLink]="[routeNameConstants.TOOLS_DETAILS_CHILD_STATUS]"
            [routerLinkActive]="['active']">
            {{ "tooldetailstab.status" | translate }}
          </li>
          <li
            id="tab-history"
            class="c-tab-details__item"
            [routerLink]="[routeNameConstants.TOOLS_DETAILS_CHILD_HISTORY]"
            [routerLinkActive]="['active']">
            {{ "tooldetailstab.history" | translate }}
          </li>
          <li
            id="tab-info"
            class="c-tab-details__item"
            [routerLink]="[routeNameConstants.TOOLS_DETAILS_CHILD_INFO]"
            [routerLinkActive]="['active']">
            {{ "tooldetailstab.info" | translate }}
          </li>
        </ul>
      </div>
    </div>
    <div
      *ngIf="tool"
      id="details"
      class="row u-mb-2">
      <div
        class="col-12"
        *ngIf="toolDetails">
        <router-outlet (activate)="onOutletLoaded($event)"></router-outlet>
      </div>
    </div>
  </div>
</div>
